"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var boxShadow = '0 2px 4px 0 rgba(0, 0, 0, 0.2)';

var _default = (0, _styles.makeStyles)(function (theme) {
  var _primary;

  return {
    root: _objectSpread(_objectSpread({}, theme.typography.button), {}, {
      boxSizing: 'border-box',
      height: 48,
      minWidth: '18rem',
      padding: '6px 16px',
      '&:active': {
        top: 2
      },
      '&:hover': {
        textDecoration: 'none'
      },
      '&$disabled': {
        cursor: 'not-allowed'
      },
      '&.Mui-focusVisible': {
        outline: "".concat(theme.palette.sapphire[500], " dashed 2px"),
        outlineOffset: '2px'
      }
    }),
    fullWidth: {
      width: '100%'
    },
    primary: (_primary = {
      background: theme.palette.sapphire[500],
      color: theme.palette.getContrastText(theme.palette.sapphire[500])
    }, (0, _defineProperty2.default)(_primary, ['&:link', '&:visited'], {
      color: theme.palette.getContrastText(theme.palette.sapphire[500])
    }), (0, _defineProperty2.default)(_primary, '&:hover', {
      background: theme.palette.sapphire[700],
      boxShadow: boxShadow,
      color: theme.palette.getContrastText(theme.palette.sapphire[500])
    }), (0, _defineProperty2.default)(_primary, '&:active', {
      background: theme.palette.sapphire[900],
      boxShadow: 'none'
    }), (0, _defineProperty2.default)(_primary, '&$disabled', {
      background: theme.palette.neutral.mono,
      color: theme.palette.stainless[900]
    }), _primary),
    secondary: {
      border: '1px solid',
      borderColor: theme.palette.sapphire[500],
      color: theme.palette.sapphire[500],
      '&:visited': {
        color: theme.palette.sapphire[500]
      },
      '&:hover': {
        borderColor: theme.palette.sapphire[700],
        boxShadow: boxShadow,
        color: theme.palette.sapphire[700]
      },
      '&:active': {
        background: theme.palette.sapphire[50],
        borderColor: theme.palette.sapphire[900],
        boxShadow: 'none',
        color: theme.palette.sapphire[900]
      },
      '&$disabled': {
        background: 'white',
        borderColor: theme.palette.stainless[700],
        color: theme.palette.stainless[700]
      }
    },
    tertiary: {
      color: theme.palette.sapphire[500],
      '&:visited': {
        color: theme.palette.sapphire[500]
      },
      '&:hover': {
        color: theme.palette.sapphire[700]
      },
      '&:active': {
        color: theme.palette.sapphire[900]
      },
      '&$disabled': {
        color: theme.palette.stainless[700]
      }
    },
    primaryRed: {
      background: theme.palette.cardinal[500],
      '&:hover': {
        background: theme.palette.cardinal[700],
        boxShadow: boxShadow
      },
      '&:active': {
        background: theme.palette.cardinal[900],
        boxShadow: 'none'
      },
      '&$disabled': {
        background: theme.palette.neutral.mono,
        color: theme.palette.stainless[900]
      }
    },
    secondaryRed: {
      borderColor: theme.palette.cardinal[500],
      color: theme.palette.cardinal[500],
      '&:hover': {
        borderColor: theme.palette.cardinal[700],
        color: theme.palette.cardinal[700]
      },
      '&:active': {
        background: theme.palette.cardinal[50],
        borderColor: theme.palette.cardinal[900],
        color: theme.palette.cardinal[900]
      },
      '&$disabled': {
        background: 'white',
        borderColor: theme.palette.stainless[700],
        color: theme.palette.stainless[700]
      }
    },
    tertiaryRed: {
      color: theme.palette.cardinal[500],
      '&:hover': {
        color: theme.palette.cardinal[700]
      },
      '&:active': {
        color: theme.palette.cardinal[900]
      },
      '&$disabled': {
        color: theme.palette.stainless[700]
      }
    },
    disabled: {}
  };
}, {
  name: 'pds-button'
});

exports.default = _default;
